import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var PaperAndPen = function PaperAndPen(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$secondaryColor = _ref.secondaryColor,
    secondaryColorProp = _ref$secondaryColor === void 0 ? '#6F4EF6' : _ref$secondaryColor,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  var secondaryColor = !ignoreColor ? secondaryColorProp : undefined;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M43 44.9998H37C35.35 44.9998 34 43.6498 34 41.9998V9.58728L40 3.58728L46 9.58728V41.9998C46 43.6498 44.65 44.9998 43 44.9998ZM36 10.4123V41.9998C36 42.5498 36.45 42.9998 37 42.9998H43C43.55 42.9998 44 42.5498 44 41.9998V10.4123L40 6.41228L36 10.4123Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M45 36H35V38H45V36Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M30 45H2V4H18.4125L30 15.5875V45ZM4 43H28V16.4125L17.5875 6H4V43Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M29 17H17V5H19V15H29V17Z",
      fill: color
    })]
  });
};
export default PaperAndPen;